exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box[data-v-796d0a64]{background:#fff;border-radius:10px!important;padding:20px}.box__header[data-v-796d0a64]{display:flex;align-items:center;justify-content:space-between;padding-bottom:10px;border-bottom:1px solid #e6e9ec}.box__header span[data-v-796d0a64]{color:#191919;font-weight:700;font-size:21px}.box__inputs[data-v-796d0a64]{margin-top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-796d0a64","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/pages/components/layouts/boxListFilter.vue
// module id = 1105
// module chunks = 0